module.exports = __webpack_public_path__ + "img/supplier-sysm.9308970c.jpg";